import * as React from 'react';
import { FormField, Checkbox } from '@cian/ui-kit';
import { useFormField } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var CheckboxFieldContainer = function CheckboxFieldContainer(props) {
  var _props$inputNameAttri;
  var _useFormField = useFormField({
      name: props.name
    }),
    _useFormField$field = _useFormField.field,
    value = _useFormField$field.value,
    name = _useFormField$field.name,
    _useFormField$helpers = _useFormField.helpers,
    setValue = _useFormField$helpers.setValue,
    setTouched = _useFormField$helpers.setTouched,
    _useFormField$meta = _useFormField.meta,
    touched = _useFormField$meta.touched,
    error = _useFormField$meta.error;
  var isInvalid = Boolean(touched && error);
  var checked = !!value; // value может быть undefined

  var handleChange = React.useCallback(function (_, newValue) {
    setValue(newValue, true);
    setTouched(true);
  }, [setTouched, setValue]);
  return /*#__PURE__*/_jsx(FormField, {
    label: props.label,
    errorMessage: isInvalid ? error : null,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(Checkbox, {
      onChange: handleChange,
      checked: checked,
      invalid: isInvalid,
      name: (_props$inputNameAttri = props.inputNameAttribute) !== null && _props$inputNameAttri !== void 0 ? _props$inputNameAttri : name,
      label: props.placeholder
    })
  });
};
CheckboxFieldContainer.displayName = 'CheckboxFieldContainer';